module.exports = __webpack_public_path__ + "media/fonts/Aleo-Regular-92431040a54c5d278a3aad599f024704.ttf";